import { Component, OnDestroy, OnInit } from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";
import {
  ParentEventMessage,
  ParentEventMessageType,
} from "../event-page-models/parent-event-message";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

const moreDetailsText = `כל המידע נשמר באחסון המקומי של הדפדפן. ניתן למחוק את כל המידע שנשמר על ידי  . `;

@Component({
  selector: "parent-events-messages",
  templateUrl: "./parent-events-messages.component.html",
  styleUrls: ["./parent-events-messages.component.scss"],
  animations: [
    trigger("showHide", [
      state(
        "show",
        style({
          opacity: 1,
        })
      ),
      state(
        "hide",
        style({
          opacity: 0,
        })
      ),
      transition("show => hide", [animate("0.2s")]),
      transition("* => show", [animate("0.2s")]),
      transition("hide => show", [animate("0.2s")]),
    ]),
  ],
})
export class ParentEventsMessagesComponent implements OnInit, OnDestroy {
  public messageText: string;
  public moreDetailsText = moreDetailsText;
  public ParentEventMessageType = ParentEventMessageType;
  public messageType: ParentEventMessageType = ParentEventMessageType.None;
  public showStatus: "show" | "hide" = "show";
  public readonly saveAnimation: number = 2000;
  public readonly savingText = "שומר...";
  // tslint:disable-next-line:no-empty
  public runAnimation: number = 0;
  public showInfoDetails: boolean;
  private closeInterval: number;

  constructor(
    private eventsService: EventsService,
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) {
    this.eventsService.parentEventMessage$.subscribe((msg) =>
      this.updateMessage(msg)
    );
    this.messageText = "שינוי הסטטוס נשמר בהצלחה!";
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public closeMessage() {
    this.showStatus = "hide";
    setTimeout(() => {
      this.messageText = "";
      this.messageType = ParentEventMessageType.None;
    }, 300);
  }

  public moreDetails() {
    this.showInfoDetails = true;
  }

  public deleteHistory() {}

  private closeAfterIdle(ms: number = 50000) {
    clearInterval(this.closeInterval);
    this.closeInterval = setTimeout(() => {
      this.closeMessage();
    }, ms);
  }

  private updateMessage(msg: ParentEventMessage | null) {
    this.showInfoDetails = false;

    clearInterval(this.closeInterval);
    if (msg) {
      if (msg.type === ParentEventMessageType.Saving) {
        this.savingAnimation(msg.text);
        return;
      }
      this.messageText = msg.text;
      this.messageType = msg.type;
      this.showStatus = "show";
      this.closeAfterIdle(
        msg.type === ParentEventMessageType.Details ? 10000 : 5000
      );
    } else {
      this.messageText = "";
      this.messageType = ParentEventMessageType.None;
      this.showStatus = "hide";
    }
  }

  private savingAnimation(success: string) {
    this.messageText = this.savingText;
    this.showStatus = "show";
    this.runAnimation++;
    setTimeout(() => {
      this.closeAfterIdle();
      this.messageText = success;
    }, this.saveAnimation);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-messages/parent-events-messages.component.ts